import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SiteTypeEnum } from 'src/app/shared/enums';
import { TaskService } from 'src/app/shared/services/task.service';
import { Message } from 'src/app/tasks/shared/models';

import { TaskState } from '../../shared/models/misc.model';
import { API_URL_PREFIX, JSON_CONTENT_TYPE_HEADER } from '../../shared/services/basic.service';
import { ErrorHandlingService } from '../../shared/services/error-handling.service';
import { ModerationAction } from './models';

@Injectable({
  providedIn: 'root',
})
export class ArchiveAndOtherActionsService {
  constructor(
    private http: HttpClient,
    private alcmeonContext: AlcmeonContextService,
    private taskService: TaskService,
    private ehs: ErrorHandlingService
  ) {}

  canHaveModerationAction(isPublic: boolean, siteType: SiteTypeEnum): boolean {
    return (
      isPublic &&
      [
        SiteTypeEnum.Facebook,
        SiteTypeEnum.Twitter,
        SiteTypeEnum.Instagram2,
        SiteTypeEnum.Trustpilot,
        SiteTypeEnum.Linkedin,
        SiteTypeEnum.Tiktok,
      ].includes(siteType)
    );
  }

  archiveTask(taskId: number): Observable<void> {
    const archiveTaskURL = `${API_URL_PREFIX}/${this.alcmeonContext.companyId}/task/${taskId}/archive`;
    return this.http.post<void>(archiveTaskURL, { acquire: false }, JSON_CONTENT_TYPE_HEADER).pipe(
      tap(() => this.taskService.fireTaskStateUpdateByLoggedUser(taskId, TaskState.Archived)),
      this.ehs.catchAlertAndThrowHttpError()
    );
  }

  getModerationActions(messageId: number, siteId: number): Observable<ModerationAction[]> {
    const params = new HttpParams().set('refresh_site_id', siteId);
    const url = `${API_URL_PREFIX}/api/1.0/companies/${this.alcmeonContext.companyId}/messages/${messageId}/actions-allowed`;
    return this.http.get<any>(url, { params }).pipe(
      map(response =>
        response.actions_allowed.map(action => ({
          actionType: action.action_type,
          label: action.text,
        }))
      ),
      this.ehs.catchAlertAndThrowHttpError()
    );
  }

  performModerationAction(
    siteId: number,
    taskId: number,
    messageId: number,
    actionType: string
  ): Observable<{ action: any; message: Message }> {
    const url = `${API_URL_PREFIX}/api/1.0/companies/${this.alcmeonContext.companyId}/messages/${messageId}/actions`;
    const body = {
      site_id: siteId,
      task_id: taskId,
      action_type: actionType,
    };
    return this.http
      .post<{ action: any; message: Message }>(url, body, JSON_CONTENT_TYPE_HEADER)
      .pipe(this.ehs.catchAlertAndThrowHttpError());
  }
}
